import CryptoJS from 'crypto-js'
import cryptoKeyArr from './cryptoKey'

const normalKey = process.env.VUE_APP_NODE_ENV === 'production' ? cryptoKeyArr[0] : 'ngappfgabcdefg12'

// AES/ECB解密方法
export const deAesEcb = (word) => {
  let key = normalKey
  // let iv = '偏移量要个后台一致';
  key = CryptoJS.enc.Utf8.parse(key)
  let decrypt = CryptoJS.AES.decrypt(word, key, {
    // iv: iv,
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  })
  let decryptedStr = decrypt.toString(CryptoJS.enc.Utf8)
  return decryptedStr.toString()
}

/**
 * Aes/ECB 加密方法
 * @param word 需要加密的字段
 */
export const enAesEcb = (word) => {
  if (!word) return ''
  const srcs = CryptoJS.enc.Utf8.parse(word)
  const key = CryptoJS.enc.Utf8.parse(normalKey)
  // const iv = CryptoJS.enc.Utf8.parse(normalIv)

  const encrypted = CryptoJS.AES.encrypt(srcs, key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
    // iv
  })
  return encrypted.toString()
}
